import { IconName, LPSettlementBatchStatusEnum } from '@talos/kyoko';
import type { DefaultTheme } from 'styled-components';

export type LPBatchStatusMappingWithColor = {
  icon: IconName | null;
  color: string;
  description: string;
  label: string;
};

/**
 * Get batch status mapping with icons, colors, and descriptions
 * Based on the batch status legend showing overall status of a batch
 * Late status is ignored per requirements
 */
export function getLPBatchStatusMapping(
  status: LPSettlementBatchStatusEnum,
  theme: DefaultTheme
): LPBatchStatusMappingWithColor | null {
  switch (status) {
    case LPSettlementBatchStatusEnum.Created:
      return {
        icon: IconName.Clock,
        color: theme.colors.gray['090'],
        description: 'Batch created, no incoming / outgoing transfer received',
        label: 'Not Started',
      };
    case LPSettlementBatchStatusEnum.InProgress:
      return {
        icon: IconName.ChartPie050,
        color: theme.colors.blue.default,
        description: 'At least 1 incoming/outgoing transfer received',
        label: 'In Progress',
      };
    case LPSettlementBatchStatusEnum.Settled:
      return {
        icon: IconName.CheckCircleSolid,
        color: theme.colors.green.default,
        description: 'All incoming / outgoing transfers received',
        label: 'Settled',
      };

    case LPSettlementBatchStatusEnum.Discarded:
      return {
        icon: IconName.CloseCircle,
        color: theme.colors.gray['090'],
        description: '',
        label: 'Unbatched',
      };
    // Ignore Late and other statuses
    default:
      return null;
  }
}
